export default __webpack_public_path__ + "static/media/include_6@2x.e31e7623.jpg";